import $ from 'jquery';

(()=>{
  const initFilter = () => {
    $('.js-toggle-expand-button').each(function() {
      const isInit = $(this).attr('data-is-init')
      if (isInit == true) { return }
      $(this).attr('data-is-init', true)
      const counter = $(this).parent('div').parent('div').find('table tr').not('.hidden').length;
      if(counter > 6){
        $(this).parent('div').removeAttr('hidden');
      }
    });
  
    $('.js-toggle-expand-button').unbind('click').click(function() {
      $(this).parent('div').parent('div').toggleClass( "is-expand" );
    });
  }
  $(document).ready(()=>{
    initFilter()
  })

  document.addEventListener('wow-dd.filter.init', () => {
    initFilter()
  }, false);
})()